import { SubLayout } from '@/components/layouts'
const routes = {
  path: '/purchase',
  redirect: '/purchase/purchaseList',
  component: SubLayout,
  children: [
    {
      path: 'purchaseList',
      name: 'purchaseList',
      meta: {
        title: '采购管理'
      },
      component: () => import('@/views/purchase/Index')
    },
    {
      path: 'centralizedPlan',
      name: 'centralizedPlan',
      meta: {
        title: '进货管理'
      },
      component: () => import('@/views/purchase/CentralizedPlan')
    }
  ]
}

export default routes
